<template lang="pug">
    v-dialog(v-model="dialog" fullscreen)
        v-fade-transition
            v-card(v-if="dialog")
                v-app-bar(flat color="transparent" floating absolute)
                    v-tooltip(bottom)
                        template(v-slot:activator='{ on }')
                            v-btn(color='primary' dark v-on='on' icon @click="close")
                                v-icon(medium) mdi-close
                        span Exit
                    v-spacer
                    v-tooltip(bottom)
                        template(v-slot:activator='{ on }')
                            v-btn(color='primary' dark v-on='on' icon @click="download")
                                v-icon(medium) mdi-cloud-download-outline
                        span Download

                v-carousel(
                    v-model="carousel"
                    :cycle="false"
                    :light="false"
                    :hide-delimiters="false"
                    :show-arrows="true"
                    :height="'100vh'"
                ).elevation-0
                    v-carousel-item(
                        v-for="(item, i) in images"
                        :key="i"
                        :src="item.url"
                        contain
                        eager
                    )
</template>

<script>
export default {
  name: "ImageViewer",
  data() {
    return {
      dialog: false,
      images: [],
      carousel: null
    };
  },
  methods: {
    show(images, index) {
      this.images = [...images];
      this.carousel = index;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.images.length = 0;
        this.carousel = null;
      });
    },
    download() {
      this.$emit("download", { images: this.images, index: this.carousel });
      // window.open(this.images[this.carousel].image.url_download);
    }
  }
};
</script>

<style scoped></style>
